/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Err_Password_TitleInputs */

const es_cap_err_password_title = /** @type {(inputs: Cap_Err_Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña`)
};

const gl_cap_err_password_title = /** @type {(inputs: Cap_Err_Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrasinal`)
};

const en_cap_err_password_title = /** @type {(inputs: Cap_Err_Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

/**
* | output |
* | --- |
* | "Password" |
*
* @param {Cap_Err_Password_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_err_password_title = /** @type {((inputs?: Cap_Err_Password_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Err_Password_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_err_password_title(inputs)
	if (locale === "en") return en_cap_err_password_title(inputs)
	return es_cap_err_password_title(inputs)
});